<template>
    <div class="contact-item">
        <el-select class="select" v-model="contactType" @change="handleChange">
            <el-option
                v-for="item in selectOption"
                :value="item.value"
                :label="item.label"
                :key="item.value"
            />
        </el-select>
        <el-input
            class="input"
            v-model.trim="contactInfo"
            @change="handleChange"
        ></el-input>
        <el-button type="text" @click="$emit('del')">删除</el-button>
        <el-button type="text" @click="$emit('up')">上移</el-button>
        <el-button type="text" @click="$emit('down')">下移</el-button>
    </div>
</template>

<script>
export default {
    props: {
        value: Object,
        selectOption: Array,
    },
    data() {
        return {
            contactId: "", // 联系方式ID，字段为空代表新增
            contactType: "", // 联系方式类型ID
            contactInfo: "", // 联系方式
        };
    },
    watch: {
        value: {
            handler(val) {
                if (val) {
                    this.contactId = val.contactId;
                    this.contactType = val.contactType;
                    this.contactInfo = val.contactInfo;
                }
            },
            immediate: true,
        },
    },
    methods: {
        handleChange() {
            this.$emit("change", {
                contactId: this.contactId, // 联系方式ID，字段为空代表新增
                contactType: this.contactType, // 联系方式类型ID
                contactInfo: this.contactInfo, // 联系方式
            });
        },
    },
};
</script>

<style scoped lang="stylus">
.contact-item {
    margin-bottom: 10px;
    .select {
        width: 110px;
        margin-right: 10px;
    }
    .input {
        width: 220px;
        margin-right: 15px;
    }
}
</style>
